// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-title__extended[data-v-2d4890bf] .dot {\n  background-color: #fff !important;\n}\n.custom-bg[data-v-2d4890bf] {\n  background-color: #f7f7f7;\n}", ""]);
// Exports
module.exports = exports;
